import React from 'react';
import PropTypes from 'prop-types';


function PrivateContentDescription(props) {
  const {
    shouldShowDescription,
    media,
    title,
    leftTitle,
  } = props;
  if (!shouldShowDescription) {
    return null;
  }

  return (
    <div className="content-item-caption private-video-caption">
      <div className="content-item-title private-video-title">
        {title}
      </div>
      <div className="private-video-desc">
        <span className="private-gallery-image-count">{leftTitle}</span>
        <span>{media.anchorName}</span>
      </div>
    </div>
  );
}

export default PrivateContentDescription;

PrivateContentDescription.propTypes = {
  shouldShowDescription: PropTypes.bool,
  media: PropTypes.object.isRequired,
  title: PropTypes.string,
  leftTitle: PropTypes.string,
};

